import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate, useParams } from "react-router-dom";
import { db, functions } from "../firebase";
import { httpsCallable } from "firebase/functions";
import "../styles/Volunteers.css";

export default function BusinessOTPVerification() {
  const { submissionId } = useParams();
  const navigate = useNavigate();
  const sendBusinessOTP = httpsCallable(functions, "sendBusinessOTP");
  const verifyBusinessOTP = httpsCallable(functions, "verifyBusinessOTP");

  const [loading, setLoading] = useState(true);
  const [business, setBusiness] = useState(null);

  const [otp, setOtp] = useState("");

  const [sending, setSending] = useState(false);
  const [verifying, setVerifying] = useState(false);

  useEffect(() => {
  loadSubmission();
}, []);

useEffect(() => {
  if (business) {
    sendOTP();
  }
}, [business]);

  const loadSubmission = async () => {
    try {
      const snap = await getDoc(
        doc(db, "businessSubmissions", submissionId)
      );

      if (!snap.exists()) {
        alert("Submission not found.");
        navigate("/volunteers");
        return;
      }

      setBusiness(snap.data());
    } catch (err) {
      console.error(err);
      alert("Unable to load submission.");
    }

    setLoading(false);
  };

  const maskMobile = (mobile = "") => {
    if (mobile.length !== 10) return mobile;
    return `${mobile.substring(0, 2)}XXXXXX${mobile.substring(8)}`;
  };

const sendOTP = async () => {
  setSending(true);

  try {
    await sendBusinessOTP({
      submissionId,
    });

    alert(
      "OTP has been generated.\n\n(For now check Firebase Functions logs.)"
    );
  } catch (err) {
    console.error(err);
    alert(err.message);
  }

  setSending(false);
};

  const verifyOTP = async () => {
  if (otp.length !== 6) {
    alert("Enter a valid 6-digit OTP.");
    return;
  }

  setVerifying(true);

  try {
    const result = await verifyBusinessOTP({
      submissionId,
      otp,
    });

    if (result.data.success) {
      alert("Business verified successfully!");

      navigate("/shops");
    }
  } catch (err) {
    console.error(err);
    alert(err.message);
  }

  setVerifying(false);
};

  if (loading) {
    return (
      <div className="volunteers-page">
        <div className="volunteer-form">
          <h3>Loading...</h3>
        </div>
      </div>
    );
  }

  return (
    <div className="volunteers-page">

      <div className="volunteers-header">
        <h2>📱 Business Verification</h2>

        <p>
          Verify the business owner's mobile number to publish this business
          on Eyal App.
        </p>
      </div>

      <div className="volunteer-form">

        <div className="form-group">
          <label>Business</label>

          <input
            value={business.businessName}
            readOnly
          />
        </div>

        <div className="form-group">
          <label>Business Mobile</label>

          <input
            value={maskMobile(business.mobile)}
            readOnly
          />
        </div>

        <button
          className="submit-btn"
          type="button"
          onClick={sendOTP}
          disabled={sending}
        >
          {sending ? "Sending OTP..." : "Send OTP"}
        </button>

        <div
          className="form-group"
          style={{ marginTop: 25 }}
        >
          <label>Enter OTP</label>

          <input
            type="text"
            value={otp}
            maxLength={6}
            onChange={(e) =>
              setOtp(e.target.value.replace(/\D/g, ""))
            }
            placeholder="6-digit OTP"
          />
        </div>

        <button
          className="submit-btn"
          type="button"
          onClick={verifyOTP}
          disabled={verifying}
        >
          {verifying ? "Verifying..." : "Verify OTP"}
        </button>

      </div>

    </div>
  );
}